
import React from 'react'

const AuthStateContext = React.createContext(false);

export default AuthStateContext;